var render = function render(){var _vm=this,_c=_vm._self._c;return _c('g',[_c('path',{attrs:{"d":"M13.6663 0H0.333008L5.66634 6.30667V10.6667L8.33301 12V6.30667L13.6663 0Z","fill":_vm.iconFill}})])
}
var staticRenderFns = []

export { render, staticRenderFns }